// Home button

import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { PowerBtn } from '../components/AllSvgs'


const Power = styled.button`
position: fixed;
top: 2rem;
right:15px;
transform: translate(-50%, 0);

background-color: #FCF6F4;
padding: 0.3rem;
border-radius: 50%;
border: 1px solid #000;
width: 2.2rem;
height: 2.2rem;

display: flex;
justify-content: center;
align-items:center;
z-index:3;

cursor: pointer;

@media (max-width: 600px) {
    z-index:7000;
    margin-top:0rem;
    width: 2rem;
height: 1.8rem;

   
}

&:hover{
    background-color: rgba(256,,256,0.4);
    box-shadow: 0 0 8px 6px rgba(256,246,256,256.2);
}

&>*:first-child{
    text-decoration: none;
    color: inherit;
}
`

const PowerButton = () => {
    return (
        <Power>
        <NavLink to="/">
        <PowerBtn width={30} height={30} fill='currentColor' />
        </NavLink>
        </Power>
    )
}

export default PowerButton
